// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.ERPLogin_loginShortCutContainer__dt-go {
  position: fixed;
  top: 50%;
  right: 30px;
  transform: translateY(-50%);
  width: 50px;
  /* height: 50px; */
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  row-gap: 20px;
}
.ERPLogin_loginShortCutP__dJb3L {
  /* position: fixed;
  top: 260px;
  right: 30px;
  transform: translateY(-50%); */
  width: 50px;
  height: 50px;
  opacity: 0;
  background-color: transparent;
  border-radius: 8px;
  /* cursor: url("/src/images/Magic/harry-potter.svg"); */
  display: flex;
  align-items: center;
  justify-content: center;
}
.ERPLogin_loginShortCut__J5rJk {
  /* position: fixed;
  top: 200px;
  right: 30px;
  transform: translateY(-50%); */
  width: 50px;
  height: 50px;
  opacity: 0;
  background-color: transparent;
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  /* cursor: url("/src/images/Magic/harry-potter.svg"); */
}
.ERPLogin_loginShortCutP__dJb3L:hover,
.ERPLogin_loginShortCut__J5rJk:hover {
  opacity: 0.16;
  border: 2px solid #252525;
}
`, "",{"version":3,"sources":["webpack://./src/pages/DefaultPages/ERPLogin/ERPLogin.module.css"],"names":[],"mappings":"AAAA;EACE,eAAe;EACf,QAAQ;EACR,WAAW;EACX,2BAA2B;EAC3B,WAAW;EACX,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,sBAAsB;EACtB,aAAa;AACf;AACA;EACE;;;gCAG8B;EAC9B,WAAW;EACX,YAAY;EACZ,UAAU;EACV,6BAA6B;EAC7B,kBAAkB;EAClB,uDAAuD;EACvD,aAAa;EACb,mBAAmB;EACnB,uBAAuB;AACzB;AACA;EACE;;;gCAG8B;EAC9B,WAAW;EACX,YAAY;EACZ,UAAU;EACV,6BAA6B;EAC7B,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,uDAAuD;AACzD;AACA;;EAEE,aAAa;EACb,yBAAyB;AAC3B","sourcesContent":[".loginShortCutContainer {\r\n  position: fixed;\r\n  top: 50%;\r\n  right: 30px;\r\n  transform: translateY(-50%);\r\n  width: 50px;\r\n  /* height: 50px; */\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  flex-direction: column;\r\n  row-gap: 20px;\r\n}\r\n.loginShortCutP {\r\n  /* position: fixed;\r\n  top: 260px;\r\n  right: 30px;\r\n  transform: translateY(-50%); */\r\n  width: 50px;\r\n  height: 50px;\r\n  opacity: 0;\r\n  background-color: transparent;\r\n  border-radius: 8px;\r\n  /* cursor: url(\"/src/images/Magic/harry-potter.svg\"); */\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n}\r\n.loginShortCut {\r\n  /* position: fixed;\r\n  top: 200px;\r\n  right: 30px;\r\n  transform: translateY(-50%); */\r\n  width: 50px;\r\n  height: 50px;\r\n  opacity: 0;\r\n  background-color: transparent;\r\n  border-radius: 8px;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  /* cursor: url(\"/src/images/Magic/harry-potter.svg\"); */\r\n}\r\n.loginShortCutP:hover,\r\n.loginShortCut:hover {\r\n  opacity: 0.16;\r\n  border: 2px solid #252525;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"loginShortCutContainer": `ERPLogin_loginShortCutContainer__dt-go`,
	"loginShortCutP": `ERPLogin_loginShortCutP__dJb3L`,
	"loginShortCut": `ERPLogin_loginShortCut__J5rJk`
};
export default ___CSS_LOADER_EXPORT___;
